import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["page", "counter", "highlight"]

  connect() {
    this.index = 1;
  }

  highlightRegion(regionToHighlight) {
    const { page_number, bounding_box } = regionToHighlight
    this.removeHighlight();

    this.#showPage(page_number);

    const page = this.pageTargets[page_number - 1];

    const img = page.querySelector("img");
    const highlight = this.highlightTargets[page_number - 1];

    // We need scaleX and scaleY because the image will not be displayed at
    // 100% if the browser window isn't large enough.
    // naturalWidth and naturalHeight are the sizes of the image at 100%
    // clientWidth and clientHeight are the size actually being displayed
    // We use those numbers to calculate the scale and use the scale
    // to place the red box in the correct coordinates
    const scaleX = img.clientWidth / img.naturalWidth
    const scaleY = img.clientHeight / img.naturalHeight

    // Multiply by 300 because the DPI is 300
    const left = bounding_box["left"] * 300
    const top = bounding_box["top"] * 300
    const width = bounding_box["width"] * 300
    const height = bounding_box["height"] * 300

    // I added the hardcoded px numbers to pad out the highlight box
    // so it's not visually right up against the data because that might
    // obscure some text
    highlight.style.left = `${(left * scaleX) - 40}px`
    highlight.style.top = `${(top * scaleY) - 3}px`
    highlight.style.width = `${((width - left) * scaleX) + 100}px`
    highlight.style.height = `${((height - top) * scaleY) + 6}px`
    highlight.classList.remove("hidden");
  }

  next() {
    if (this.index < this.pageTargets.length) {
      this.index++;
      this.#showPage(this.index);
    }
  }

  previous() {
    if (this.index > 1) {
      this.index--;
      this.#showPage(this.index);
    }
  }

  removeHighlight() {
    this.highlightTargets.forEach(highlightTarget => highlightTarget.classList.add("hidden"));
  }

  #showPage(page_number) {
    this.pageTargets.forEach((page, index) => {
      page.classList.toggle("hidden", (index + 1) !== page_number)
    })
    this.counterTarget.textContent =
      `${page_number} of ${this.pageTargets.length}`;
    this.index = page_number;
  }
}